
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DevicesDto } from './devices.dto';

export class DevicesResponse extends GlobalResponseObject {
    data?: DevicesDto[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DevicesDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}